import * as msgpack from '@mta/msgpack-js-lib';

export default class ExternalUser {
	constructor(
			/** ?int= */ id = null,
			/** ?string= */ firstname = '',
			/** ?string= */ lastname = '',
			/** ?string= */ username = '',
			/** ?string= */ email = '',
			/** ?string= */ password = '',
			/** ?string= */ companyName = '',
			/** !boolean= */ isActive = false,
			/** !boolean= */ isVerified = false,
			/** Array<ApplicationAccess>= */ applicationAccesses = []
	) {
		/** @member {?int} */
		this.id = id;
		/** @member {?string} */
		this.firstname = firstname;
		/** @member {?string} */
		this.lastname = lastname;
		/** @member {?string} */
		this.username = username;
		/** @member {?string} */
		this.email = email;
		/** @member {?string} */
		this.password = password;
		/** @member {?string} */
		this.companyName = companyName;
		/** @member {!boolean} */
		this.isActive = isActive;
		/** @member {!boolean} */
		this.isVerified = isVerified;
		/** @member {Array<ApplicationAccess>} */
		this.applicationAccesses = applicationAccesses;
	}

	/**
	 * @param {!object} os
	 * @param {!function} genericTypePackers
	 * @param {Number} __uid__
	 * @return {object}
	 */
	pack(os, genericTypePackers, __uid__) {
		return {
			__uid__: __uid__,
			id: os.writeNullableInt(this.id),
			firstname: os.writeString(this.firstname),
			lastname: os.writeString(this.lastname),
			username: os.writeString(this.username),
			email: os.writeString(this.email),
			password: os.writeString(this.password),
			companyName: os.writeString(this.companyName),
			isActive: os.writeBoolean(this.isActive),
			isVerified: os.writeBoolean(this.isVerified),
			applicationAccesses: os.writeList(this.applicationAccesses, (value0) => os.writeObject(value0))
		};
	}

	/**
	 * @param {!object} is
	 * @param {ExternalUser} value
	 */
	unpack(is, value) {
		if (value.id !== undefined)
			this.id = is.readNullableLong(value.id);
		if (value.firstname !== undefined)
			this.firstname = is.readString(value.firstname);
		if (value.lastname !== undefined)
			this.lastname = is.readString(value.lastname);
		if (value.username !== undefined)
			this.username = is.readString(value.username);
		if (value.email !== undefined)
			this.email = is.readString(value.email);
		if (value.password !== undefined)
			this.password = is.readString(value.password);
		if (value.companyName !== undefined)
			this.companyName = is.readString(value.companyName);
		if (value.isActive !== undefined)
			this.isActive = is.readBoolean(value.isActive);
		if (value.isVerified !== undefined)
			this.isVerified = is.readBoolean(value.isVerified);
		if (value.applicationAccesses !== undefined)
			this.applicationAccesses = is.readList(value.applicationAccesses, (value0) => is.readObject(value0, () => new msgpack.gen.com.arabellesolutions.sdc.b2b.common.application.ApplicationAccess()));
	}
}

msgpack.registerClass('com.arabellesolutions.sdc.b2b.common.user.ExternalUser', ExternalUser);
